import { davimaDocValidations } from "./davima";
import { telparkDocValidations } from "./telpark";

export const docValidations = {
  ...telparkDocValidations,
  ...davimaDocValidations,
  doc_validation_docdate_greater_accountingdate: `Document date cannot be greater than accounting date`,
};
